import { api_configuration } from "../../common";
import api_client_state = api_configuration.types.client_state.alan_api;
import Window = require("../widgets/dom/Window");
import { removeQueryEntryDependencies } from "./Entry";

type EntryWithDependencies = {
	__id_path_dependencies?: Set<api_client_state.Cclient_id_path>;
};

function getDependencies(entry: api_client_state.Centries__collection): Set<api_client_state.Cclient_id_path> {
	const entry_with_dependencies = entry as any as EntryWithDependencies;
	if (!entry_with_dependencies.__id_path_dependencies) {
		entry_with_dependencies.__id_path_dependencies = new Set();
	}
	return entry_with_dependencies.__id_path_dependencies!;
}

export function linkIdPath(id_path: api_client_state.Cclient_id_path): void {
	let has_steps = id_path.properties.has_steps;
	while (has_steps.state.name === "yes") {
		const step = has_steps.state.node;
		switch (step.properties.type.state.name) {
			case "group":
				break;
			case "state":
				break;
			case "operation":
				break;
			case "collection entry": {
				const collection_entry = step.properties.type.state.node;
				const dependencies = getDependencies(collection_entry.properties.entry.ref);
				dependencies.add(id_path);
				id_path.onDestroy(() => {
					dependencies.delete(id_path);
				});
				break;
			}
		}
		has_steps = step.properties.tail.properties.has_steps;
	}
}

export function handleEntryRemoval(entry: api_client_state.Centries__collection): void {
	const entry_with_dependencies = entry as any as EntryWithDependencies;
	if (entry_with_dependencies.__id_path_dependencies !== undefined && !entry.destroyed) {
		for (const id_path of entry_with_dependencies.__id_path_dependencies) {
			const location = id_path.input.location();
			switch (location.variant.name) {
				case "view": {
					const view = location.variant.definition;
					if (!view.destroyed) {
						const window = view.parent;
						Window.getWindowInstance(window.key.entry).close_view(view);
					}
					break;
				}
				case "join": {
					const join = location.variant.definition;
					if (!join.destroyed) {
						join.root.transact(() => {
							join.parent.properties.joined_collection.set("unresolved", {});
							for (const [, entry] of join.parent.properties.entries) {
								entry.properties.referenced_entry.ensure("none", {});
							}
						});
					}
					break;
				}
				case "query entry": {
					const query_entry = location.variant.definition;
					if (!query_entry.destroyed) {
						const requery_needed = entry.properties.location.switch({
							remote: ($) =>
								$.properties.marked_for_deletion.switch({
									yes: false,
									no: true,
								}),
							local: false,
						});
						removeQueryEntryDependencies(query_entry.parent, requery_needed);
					}
				}
			}
		}
	}
}
